import { Link } from 'react-router-dom';

export default function UeberUnsPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Über uns
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
              Weil der Mensch<br />den Menschen braucht.
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              asK-mi ist ein Kompetenzzentrum für menschliche Intelligenz – eine Förder- und Entwicklungsorganisation 
              für junge Menschen aus dem neurodiversen Spektrum.
            </p>
          </div>
        </div>
      </section>

      {/* Warum gibt es asK-mi */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
                Warum gibt es asK-mi?
              </span>
              <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
                Wir sehen den Menschen – nicht die Diagnose.
              </h2>
              <div className="text-[17px] text-gray-600 leading-relaxed space-y-4">
                <p>
                  Viele junge Menschen aus dem neurodiversen Spektrum werden vor allem über ihre Schwierigkeiten wahrgenommen.
                </p>
                <p>
                  ADS, ADHS oder Autismus beschreiben einen Teil eines Menschen. 
                  <strong className="text-gray-900"> Sie definieren nicht seinen Wert.</strong>
                </p>
                <p>
                  asK-mi möchte den Blick verändern: Wir sehen Menschen mit individuellen Fähigkeiten, 
                  besonderen Wahrnehmungen, ungewöhnlichen Denkweisen, Kreativität und Entwicklungspotenzial.
                </p>
                <p>
                  Neurodiversität ist Teil menschlicher Vielfalt. Junge Menschen brauchen nicht immer mehr Anpassung – 
                  manchmal brauchen sie ein Umfeld, das ihre Fähigkeiten erkennt.
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/d4ed44b3-63d8-417d-957c-4836bdf688a4/images/8e88facd68bd457e511ae18326ba12c8dcc9a338b5b466ff273bcc92deacf675.jpeg" 
                alt="Menschen in Begegnung - gemeinsam gestalten"
                className="w-full h-[450px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Unsere Haltung */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Unsere Haltung
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Wofür wir stehen.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl p-8 border-l-4 border-[#C4A962]">
              <h3 className="font-bold text-lg text-gray-900 mb-3">Der Mensch im Mittelpunkt</h3>
              <p className="text-gray-600 leading-relaxed">
                Nicht die Diagnose definiert den Menschen. Wir sehen Fähigkeiten, Potenziale und Möglichkeiten.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border-l-4 border-[#C4A962]">
              <h3 className="font-bold text-lg text-gray-900 mb-3">Vielfalt als Stärke</h3>
              <p className="text-gray-600 leading-relaxed">
                Neurodiversität ist Teil menschlicher Vielfalt. Unterschiedliche Denkweisen bereichern unsere Gesellschaft.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border-l-4 border-[#C4A962]">
              <h3 className="font-bold text-lg text-gray-900 mb-3">Förderung mit Wirkung</h3>
              <p className="text-gray-600 leading-relaxed">
                Förderung bedeutet für uns: Möglichkeiten schaffen, Beziehungen ermöglichen, Zugänge öffnen.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border-l-4 border-[#C4A962]">
              <h3 className="font-bold text-lg text-gray-900 mb-3">Verantwortung übernehmen</h3>
              <p className="text-gray-600 leading-relaxed">
                Wir handeln transparent, nachvollziehbar und im Interesse der Menschen, die wir fördern.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Wie wir arbeiten */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Wie wir arbeiten
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Verbinden. Ermöglichen. Wirken.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-[#C4A962]/10 flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">🤝</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Verbinden</h3>
              <p className="text-gray-600 leading-relaxed">
                Wir bringen Förderer, Menschen, Einrichtungen, Unternehmen und Projekte zusammen.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-[#C4A962]/10 flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">✨</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Ermöglichen</h3>
              <p className="text-gray-600 leading-relaxed">
                Wir prüfen, wählen aus und ermöglichen gezielte, wirkungsvolle Förderung.
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-[#C4A962]/10 flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">💡</span>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">Wirken</h3>
              <p className="text-gray-600 leading-relaxed">
                Jede Förderung schafft konkrete Veränderung im Leben junger Menschen und ihrer Familien.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Verantwortliche */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Verantwortung
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Verantwortliche Personen
            </h2>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-xl p-8 border border-[#E8E4DE]">
              <p className="text-gray-600 leading-relaxed mb-4">
                asK-mi wird von einem engagierten Team geführt, das sich für die Förderung junger Menschen 
                aus dem neurodiversen Spektrum einsetzt.
              </p>
              <p className="text-gray-600 leading-relaxed mb-6">
                Für Fragen zur Organisation, Partnerschaft oder Förderung stehen wir Ihnen gerne zur Verfügung.
              </p>
              <Link 
                to="/kontakt"
                className="inline-flex items-center gap-2 text-[#A8923F] font-medium hover:underline"
              >
                Kontakt aufnehmen →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[42px] font-bold tracking-tight mb-6">
            Werden Sie Teil unserer Mission.
          </h2>
          <p className="text-lg text-white/70 max-w-xl mx-auto mb-10">
            Gemeinsam können wir jungen Menschen neue Möglichkeiten eröffnen.
          </p>
          <Link 
            to="/foerderer-werden"
            className="inline-flex items-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
          >
            Förderer werden
          </Link>
        </div>
      </section>
    </div>
  );
}
